import { BoostEventSearchModal } from './BoostEventSearchModal';
import { wideSearchDialog } from './BoostEventSearchModal.css';

export const BoostEventSearchModalConfig = {
  children: <BoostEventSearchModal />,
  clickOutsideToClose: true,
  // slide-in-md dialog widened to 800px via the dialog class (between the
  // 600px slide-in-md and 1000px slide-in sizes)
  size: 'slide-in-md',
  className: wideSearchDialog,
};
